import { Workflow } from '@/app/workflows/actions/interfaces';
import { ComponentType, EditField } from './EditField';

export type EditDescriptionProps = {
  defaultName: string;
  setIsEdit: (isEdit: boolean) => void;
  workflow: Workflow;
};

export function EditDescription({ defaultName, setIsEdit, workflow }: EditDescriptionProps) {
  return (
    <EditField
      type={ComponentType.TextArea}
      defaultValue={defaultName}
      setIsEdit={setIsEdit}
      field='description'
      workflow={workflow}
    />
  );
}
